import config from '../../../config';

export const menuItems = [
  {
    displayName: 'COMPLETE TEACHING<br/>RESOURCES',
    urlPath: `${config.subsitesUrl.tr}/dashboard/tr`,
    isProtected: false,
    hideAfterLogin: false,
    className: `navigation-color-green`,
  },
  {
    displayName: 'SINGLE/BUNDLED<br/>TEACHING<br />RESOURCES',
    urlPath: `${config.subsitesUrl.dvr}/search?resource-types=teaching-resources`,
    isProtected: false,
    hideAfterLogin: false,
    className: `navigation-color-green`,
  },
  {
    displayName: 'STUDENT<br/>LEARNING<br/>RESOURCES',
    className: `navigation-color-blue`,
    urlPath: `/search?resource-types=student-learning-resources`,
    isProtected: false,
    hideAfterLogin: false,
  },
  {
    className: `navigation-color-red`,
    displayName: 'PROFESSIONAL<br/>LEARNING<br/>RESOURCES',
    urlPath: `${config.subsitesUrl.dvr}/search?resource-types=professional-learning-resources`,
    isProtected: false,
  },
  {
    className: `navigation-color-yellow`,
    displayName: `SEE<br/>WHAT'S NEW<br/>ON THE SITE`,
    urlPath: `${config.pageBuilderUrls.main}/whats-new`,
    isProtected: false,
  },
  {
    displayName: 'MY<br/>ACCOUNT',
    urlPath: 'subscription/invoices',
    sideMenuId: 'myaccount',
    className: `navigation-color-purple`,
    isProtected: true,
    hasSidebar: true,
  },
];

export const sidemenuItems = [
  {
    displayName: 'Digital Resources',
    urlPath: '/',
    isProtected: false,
    isHexIcon: true,
    iconName: '',
    iconText: 'DRs',
  },
  {
    displayName: 'Search',
    urlPath: '/search',
    isProtected: false,
    isHexIcon: false,
    iconName: 'fa-regular fa-magnifying-glass',
  },
  {
    displayName: 'My Resources',
    urlPath: `/subscription/resources`,
    isProtected: false,
    isHexIcon: false,
    iconName: 'fa-regular fa-book-open-cover',
  },
  {
    displayName: 'My Cart',
    urlPath: `/subscription/cart`,
    isProtected: false,
    isHexIcon: false,
    iconName: 'fa-regular fa-cart-shopping',
  },
  {
    displayName: 'My Wishlist',
    urlPath: `/subscription/wishlist`,
    isProtected: false,
    isHexIcon: false,
    iconName: 'fa-regular fa-wand-magic-sparkles',
  },
  {
    displayName: 'My Account',
    urlPath: `/subscription/invoices`,
    isProtected: false,
    isHexIcon: false,
    iconName: 'fa-regular fa-user',
  },
];

export const sidemenuItemsNoUser = [
  {
    displayName: 'Digital Resources',
    urlPath: '/',
    isProtected: false,
    isHexIcon: true,
    iconName: '',
    iconText: 'DRs',
  },
  {
    displayName: 'Search',
    urlPath: '/search',
    isProtected: false,
    isHexIcon: false,
    iconName: 'fa-regular fa-magnifying-glass',
  },
];

export const footerPages = [
  {
    displayName: 'Look Around',
    urlPath: `${config.pageBuilderUrls.main}/look-around`,
    isProtected: false,
  },
  {
    displayName: 'Relational Mathematics',
    urlPath: `${config.pageBuilderUrls.main}/relational-understanding`,
    isProtected: false,
  },
  {
    displayName: 'Research-base',
    urlPath: `${config.pageBuilderUrls.main}/research-base`,
    isProtected: false,
  },
  {
    displayName: 'Free Resources',
    urlPath: `${config.pageBuilderUrls.main}/free-resources`,
    isProtected: false,
  },
];

export const sitepages = [
  // {
  //   name: 'My Account',
  //   url: '',
  // },
  // {
  //   name: 'Membership',
  //   url: '',
  // },
  {
    name: 'About / Contact',
    url: `${config.pageBuilderUrls.main}/about-contact`,
  },
  {
    name: 'Terms & Conditions',
    url: `${config.subsitesUrl.main}/agreement/termsandconditions`,
  },
  {
    name: 'Privacy Policy',
    url: `${config.subsitesUrl.main}/agreement/privacypolicy`,
  },
  {
    name: 'What’s New?',
    url: `${config.pageBuilderUrls.main}/whats-new`,
  },
];

export const footerSubsites = [
  {
    name: 'Homepage',
    url: '/',
    short_code: 'HOME',
  },
  {
    name: 'Teaching Resources',
    // url: config.subsiteUrl.tr,
    url: 'dashboard/tr',
    short_code: 'TR',
  },
  {
    name: 'Maths Scope and Sequences',
    url: `${config.pageBuilderUrls.main}/tr-s-and-s`,
    short_code: 'SAS',
  },
  {
    name: 'Maths Concept Sequences',
    url: `${config.pageBuilderUrls.main}/tr-s-and-s`,
    short_code: 'SAS',
  },
  {
    name: 'Assessment & Tracking',
    url: `${config.pageBuilderUrls.main}/assessment-tracking`,
    short_code: 'TAR',
  },
  {
    name: 'Professional Learning',
    // url: config.subsiteUrls.ftd,
    url: `${config.pageBuilderUrls.main}/professional-learning`,
    short_code: '4TD',
  },
  {
    name: 'Student Resources',
    // url: config.subsiteUrls.slr,
    url: `${config.pageBuilderUrls.main}/student-learning-resources`,
    short_code: 'SLR',
  },
  {
    name: 'Digital Resources',
    url: `${config.pageBuilderUrls.main}/digital-resources`,
    short_code: 'DVR',
  },
];

export const socmed = [
  {
    icon: 'alp-fb',
    url: 'https://www.facebook.com/alearningplaceateachingplace',
  },
  // {
  //   icon: 'alp-linkedin',
  //   url: '#',
  // },
  {
    icon: 'alp-instagram',
    url: 'https://www.instagram.com/alearningplaceateachingplace/',
  },
  // {
  //   icon: 'alp-youtube',
  //   url: '#',
  // },
];

export const boxColor = new Map();
boxColor.set(0, 'green');
boxColor.set(1, 'yellow');
boxColor.set(2, 'red');
boxColor.set(3, 'brown');
boxColor.set(4, 'blue');
boxColor.set(5, 'lightblue');
boxColor.set(6, 'purple');

export const scopeSequenceColor = new Map();
scopeSequenceColor.set(0, 'green');
scopeSequenceColor.set(1, 'yellow');
scopeSequenceColor.set(2, 'red');
scopeSequenceColor.set(3, 'purple');
scopeSequenceColor.set(4, 'blue');
